import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=470756be"
import script from "./Export.vue?vue&type=script&lang=ts"
export * from "./Export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports